import './App.css';

import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import MeetingRoom from './views/MeetingRoom';
import MainPage from './views/MenuPage';
import { useT } from './i18n';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

function App() {
  const t = useT();
  const [license, setLicense] = useState({ state: 'loading' });

  const checkLicense = useCallback(() => {
    let active = true;
    setLicense({ state: 'loading' });

    fetch(`${API_BASE_URL}/api/license/status`)
      .then(async (response) => {
        const data = await response.json();
        if (!active) return;
        setLicense(data.valid
          ? { state: 'valid', ...data }
          : { state: 'invalid', ...data });
      })
      .catch(() => {
        if (active) {
          setLicense({
            state: 'unavailable',
            messageKey: 'license.unreachable',
          });
        }
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => checkLicense(), [checkLicense]);

  window.__BUILD_VERSION__ = '3.0.6-20260918';

  if (license.state !== 'valid') {
    const loading = license.state === 'loading';
    return (
      <div className="App license-page" data-version="3.0.6-20260918">
        <div className="bg"></div>
        <main className="license-card" role={loading ? 'status' : 'alert'}>
          <div className={`license-icon ${loading ? 'loading' : ''}`}>
            {loading ? '…' : '!'}
          </div>
          <h1>{loading ? t('license.checking') : t('license.notLicensed')}</h1>
          <p>{loading ? t('license.wait') : (license.messageKey ? t(license.messageKey) : license.message)}</p>
          {!loading && (
            <>
              <p className="license-help">
                {t('license.howto')}
              </p>
              <button type="button" className="license-retry" onClick={checkLicense}>
                {t('license.retry')}
              </button>
            </>
          )}
        </main>
      </div>
    );
  }

  return (
    <div className="App" data-version="3.0.6-20260918">
      <div className="bg"></div>
        <Router>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/:id" element={<MeetingRoom />} />
          </Routes>
        </Router>
    </div>
  );
}

export default App;
